import React from 'react';
import { connect } from 'react-redux';
import { withFormik } from 'formik';
import * as Yup from 'yup';
import Recaptcha from 'react-recaptcha';
import { withTranslation } from 'react-i18next';
import i18next from 'i18next';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import './ContestPage.css';
import { DynamicBackground } from '../../components'
import { contestActions } from '../../actions';
import { isWebpSupported } from 'react-image-webp/dist/utils';

class ContestPageForm extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);

    const script = document.createElement("script");
    script.src =
      "https://www.google.com/recaptcha/api.js";
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
  }

  constructor(props, context) {
    super(props, context);

    this.handleClose = this.handleClose.bind(this);

    this.onCheckBoxChange = this.onCheckBoxChange.bind(this);

    this.state = {
      show: false,
    };
  }

  handleClose() {
    this.props.dispatch(contestActions.clearState())
  }

  onCheckBoxChange() {
    const { setFieldValue, values } = this.props;
    const { terms } = values;
    setFieldValue("terms", !terms);
  }

  render() {
    const {
      touched,
      errors,
      // dirty,
      setFieldValue,
      // setSubmitting,
      handleChange,
      handleSubmit,
      isValid,
      values,
      sended,
      t,
    } = this.props;

    return (
      <DynamicBackground customOverlay="rgba(0, 0, 0, 0.6)" background={isWebpSupported() ? "https://gecorcloud.com/images/backgroundContact.webp" : "https://gecorcloud.com/images/backgroundContact.jpg"}>
        <Container>
          <div className="box-contact">
            <div className="box-content">
              <div className="primers-texto">
                <h2> CONCURSO DE IDEAS <b>GECOR</b> </h2>
                <p>¡Con <b>GECOR</b> tus <b>ideas</b> tienen <b>premio</b>!</p>
              </div>
              <Col xs={12} md={12} className="img-email2">
                <div className="txt-concu">
                  <div className="img-concu">
                    <img src="https://gecorcloud.com/images/taza.png" alt="imagen-sorteo"></img>
                  </div>
                  <p>Queremos conocer tu opinión y que nos ayudes a construir <b>GECOR</b>. Cuéntanos tu idea para mejorar <b>GECOR</b> y hacerlo más útil para los ciudadanos y ciudadanas. </p>
                  <p>Si aún no nos conoces, descárgate nuestra App y empieza a participar mejorando la calidad de vida en tu ciudad.</p>
                  <div className="download-comp-ico">
                        <a href="https://play.google.com/store/apps/details?id=com.gecorsystem.gecorn&hl=es/gecor/id1127259219" target="_blank" rel="noopener noreferrer"><img src="https://gecorcloud.com/images/google-play.png" alt="download android"/></a>
                        <a href="https://apps.apple.com/es/app/gecor/id1127259219" target="_blank" rel="noopener noreferrer"><img src="https://gecorcloud.com/images/apple-store.png" alt="download android"/></a>
                   </div>
                   <br></br>
                  <p>Las 5 mejores ideas, seleccionadas por <b>GECOR</b>, se someterán a votación en nuestras redes sociales para decidir la ganadora.</p>
                  <p>Participa completando el siguiente formulario y, ¡<b>suerte</b>!</p>
                  <p>¡Cuantas más <b>ideas</b> envíes, más posibilidades tendrás de <b>ganar</b>!</p>
                  <br></br>
                  <p>*Tus datos personales se almacenan con el único propósito de contactar contigo si eres ganador/a. Una vez finalizado el concurso tus datos serán eliminados.*</p>
                </div>
              </Col>
              <Form noValidate onSubmit={handleSubmit} validated={isValid}>
                <Row className="row-box" >
                  <Col md={6} xs={12}>
                    <Form.Group as={'div'} className="div-cajas" controlId="validationFormikName">
                      <Form.Control required name="name" className="div-cajas2" placeholder={t('contactg.p1')}
                        onChange={handleChange} value={values.name} isInvalid={!!errors.name} isValid={touched.name && !errors.name} />
                      <Form.Control.Feedback type="invalid">
                        {errors.name}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group as={'div'} className="div-cajas" controlId="validationFormikEmail">
                      <Form.Control name="email" className="div-cajas2" type="email" placeholder={t('contactg.p2')}
                        required onChange={handleChange} value={values.email} isInvalid={!!errors.email} isValid={touched.email && !errors.email} />
                      <Form.Control.Feedback type="invalid">
                        {errors.email}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group as={'div'} className="div-cajas" controlId="validationFormikPhone">
                      <Form.Control name="phone" className="div-cajas2" placeholder={t('contactg.p3')}
                        required onChange={handleChange} value={values.phone} isInvalid={!!errors.phone} isValid={touched.phone && !errors.phone} />
                      <Form.Control.Feedback type="invalid">
                        {errors.phone}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={6} xs={12}>
                    <Form.Group as={'div'} className="box-mensaje" controlId="validationFormikBody">
                      <Form.Control name="body" className="box-mensaje2" placeholder="Cuéntanos tu idea*" as="textarea" maxLength="376" rows="3"
                        required onChange={handleChange} value={values.body} isInvalid={!!errors.body} isValid={touched.body && !errors.body} />
                      <Form.Control.Feedback type="invalid">
                        {errors.body}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <div className="recaptcha-g">
                      <Row>
                        <Form.Group as={Col} controlId="validationFormikTerms">
                          <Form.Check name="terms" className="color-heLeido" label={t('contactg.p5')}
                            required custom type={'checkbox'} onChange={this.onCheckBoxChange} checked={values.terms} isInvalid={!!errors.terms} feedback={errors.terms} />
                          <a className="aviso-legal" target="_blank" rel="noopener noreferrer" href="./legal-advice" >{t('contactg.p6')}</a>
                        </Form.Group>
                        { /* <confirmLegal /> */}
                        <Form.Group as={Col} controlId="recaptcha">
                          <Recaptcha
                            sitekey="6LdVQ6wUAAAAAAoJOy_Yl7UPs4Vje8IWwvU7-8T7" // V2
                            // sitekey="6LfcQqwUAAAAAOepXykaiBTSvaXr2fmJhfRIjq3_" // V3
                            render="explicit"
                            // theme="dark"
                            hl={i18next.language || window.localStorage.i18nextLng}
                            verifyCallback={(response) => { setFieldValue("recaptcha", response); }}
                            onloadCallback={() => { }}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.recaptcha}
                          </Form.Control.Feedback>
                          {errors.recaptcha
                            && touched.recaptcha && (
                              <p>{errors.recaptcha}</p>
                            )}
                        </Form.Group>

                        <Col>
                          <Button className="buttom-hazTu bottonEnv" variant="primary" type="submit"> {t('contactg.p11')} </Button>

                          <div className="modal-contact">
                            <Modal show={sended} onHide={this.handleClose}>
                              <Modal.Header closeButton>
                                <Modal.Title>¡Su idea ha sido enviada!</Modal.Title>
                              </Modal.Header>
                              <Modal.Body>
                                <p>Gracias por participar.</p>
                                <p>¡Suerte!</p>
                              </Modal.Body>
                              <Modal.Footer>
                                <Button variant="secondary" onClick={this.handleClose}>
                                  {t('contactg.p10')}
                                </Button>
                              </Modal.Footer>
                            </Modal>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
              </Form>
            </div>
          </div>
        </Container>
      </DynamicBackground>

    );
  }
}

const initialValuesFormik = {
  name: '',
  email: '',
  phone: '',
  body: '',
  terms: false,
  recaptcha: "",
}

const tContestPageForm = withTranslation()(ContestPageForm);
const formikEnhancer = withFormik({
  validationSchema: ({ t }) => Yup.object().shape({
    name: Yup.string().required('name is required.'),
    email: Yup.string().email('Invalid email address!').required('Email address is required!'),
    phone: Yup.number().required('Phone number is required!').integer().positive(),
    body: Yup.string().required('body is required.'),
    terms: Yup.boolean().required('terms is required.'),
    recaptcha: Yup.string().required(),
  }),
  mapPropsToValues: () => (initialValuesFormik),
  handleSubmit: (payload, { props, setSubmitting, resetForm }) => {
    const { terms } = payload
    if (terms) {
      props.dispatch(contestActions.newConcursoParticipacion(payload))
      setSubmitting(false)
      resetForm(initialValuesFormik)
      // handleShow();
    }

  },
  displayName: 'ContestPageForm',
})(tContestPageForm);

const mapStateToProps = (state) => {
  const { contest } = state;
  const { error, sended, sending } = contest;

  return {
    error,
    sended,
    sending,
  };
}

const tFormikEnhancer = withTranslation()(formikEnhancer)
const connectedContestPage = connect(
  mapStateToProps
)(tFormikEnhancer);
export { connectedContestPage as ContestPage };